import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "primary-container" }
const _hoisted_2 = { class: "flex justify-between mt-4" }
const _hoisted_3 = { class: "h-5 w-4 [&>svg]:stroke-current [&>svg]:h-5" }
const _hoisted_4 = {
  key: 0,
  class: "flex items-center justify-center py-8 bg-white p-6"
}
const _hoisted_5 = {
  key: 1,
  class: "form-card-tabs-container"
}
const _hoisted_6 = {
  key: 0,
  class: "flex items-center justify-center py-8 bg-white p-6"
}

import TeacherDetails from "@/modules/main/components/TeacherDetailsComponent.vue";
import GradesClassesDetailsComponent from "@/modules/main/components/GradesClassesDetailsComponent.vue";
import { onMounted, ref, watch} from "vue";
import TabView from "primevue/tabview";
import TabPanel from "primevue/tabpanel";
import { useSchoolStore } from "@/stores/schoolStore";
import { School } from "@/interfaces/school.interface";
import SchoolDetailsComponent from "./SchoolDetailsComponent.vue";
import { useLearnerStore } from "@/stores/learnerStore";


export default /*#__PURE__*/_defineComponent({
  __name: 'EditSchoolComponent',
  emits: ["updateValue"],
  setup(__props, { emit: emits }) {

const schoolStore = useSchoolStore();
const learnerStore = useLearnerStore();



const previewStep = () => {
    emits("updateValue", false);
};

const handleScrollToElement = (selector: string) => {
  const element = document.querySelector(selector);

  if (element) {
    // Scroll the element into view
    element.scrollIntoView({ behavior: 'smooth', block: 'center' });
  } else {
    console.warn(`Element with selector "${selector}" not found.`);
  }
};


return (_ctx: any,_cache: any) => {
  const _component_rl_icon = _resolveComponent("rl-icon")!
  const _component_spinner_loader = _resolveComponent("spinner-loader")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (previewStep())),
        type: "submit",
        class: "font-semibold text-gray-700 text-base border-gray-300 border rounded-lg py-2 px-4 flex items-center shadow-[0px_1px_2px_0px_rgba(16,24,40,0.05)] bg-white gap-2"
      }, [
        _createElementVNode("span", _hoisted_3, [
          _createVNode(_component_rl_icon, {
            icon: 'rl-small-back-arrow',
            title: 'rl small back arrow',
            "aria-hidden": "true"
          })
        ]),
        _createElementVNode("span", null, _toDisplayString(_ctx.$t('internal_tools.school_group.btn_back')), 1)
      ])
    ]),
    (
        _unref(schoolStore).loading === true || _unref(learnerStore).loader.learner === true
      )
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(_component_spinner_loader, { color: 'text-blue-600 dark:text-blue-600' })
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createVNode(_unref(TabView), { class: "mt-9 pb-4" }, {
            default: _withCtx(() => [
              _createVNode(_unref(TabPanel), {
                header: _ctx.$t('internal_tools.panel.school_details')
              }, {
                default: _withCtx(() => [
                  (_unref(schoolStore).loading)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                        _createVNode(_component_spinner_loader, { color: 'text-blue-600 dark:text-blue-600' })
                      ]))
                    : (_openBlock(), _createBlock(SchoolDetailsComponent, { key: 1 }))
                ]),
                _: 1
              }, 8, ["header"])
            ]),
            _: 1
          })
        ]))
  ]))
}
}

})